import React from "react";
import { SHr, SNavigation, SPage, SPopup, SText, STheme, SView } from "servisofts-component2";
// import BottomNavigator from "../../Components/BottomNavigator";
import PButtom from "../../Components/PButtom";
import Input from "../../Components/Input";
import { StyleSheet } from "react-native";
import MDL from "../../MDL";

import Message from "../../Assets/svg/message.svg";

export default class recuperar_codigo extends React.Component {
    // static FOOTER = <BottomNavigator url={"/login"} />
    constructor(props) {
        super(props);
        this.state = {
        };
        this.key = SNavigation.getParam("key");
        this.key_rol = SNavigation.getParam("key_rol");
        if (!this.key_rol) {
            this.key_rol = "d16d800e-5b8d-48ae-8fcb-99392abdf61f";
        }
    }

    inputRefs = {};
    getForm() {
        return <>
            {/* <SForm
                ref={(ref) => { this.form = ref; }}
                row
                style={{
                    justifyContent: "space-between",
                }}
                inputProps={{
                    col: "xs-12",
                }}
                inputs={{
                    correo: { placeholder: "email@example.com", type: "email", isRequired: true },
                }}
                onSubmit={(values) => {
                    Model.usuario.Action.recuperarPass({ correo: values.correo }).then(resp => {
                        SNavigation.navigate("/login/recuperar_codigo");
                    }).catch(e => {
                        console.error(e);
                    })
                }}
            /> */}
            <Input
                ref={(ref) => this.inputRefs["codigo"] = ref}
                placeholder="Ingrese el código recibido"
                required
                style={styles.input}
            />
            <SView height={16} />
            <SView col={"xs-11"} row center>
                <PButtom primary onPress={() => {
                    let data = {};
                    let vacio = false;
                    let codigo = this.inputRefs["codigo"];

                    if (!codigo.validar()) {
                        vacio = true;
                        SPopup.alert("Por favor, ingrese el código recibido.");
                        return;
                    }

                    if (!vacio) {
                        MDL.usuario.verificarCodigoPass(
                            codigo.getValue(),
                        ).then((resp) => {
                            if (resp) {
                                SNavigation.navigate("/login/recuperar_pass", resp.data);
                            } else {
                                SPopup.alert("Error en los datos");
                            }
                        }).catch((e) => {
                            console.error(e);
                            SPopup.alert("Error en los datos");
                        })
                        console.log("data", data);

                    }


                }}>Validar</PButtom>
            </SView>
        </>
    }

    render() {
        return <SPage title={"Código de Recuperación"}>
            <SView center>
                <SView col={"xs-11 md-6 xl-4"} center>
                    <SView height={40} />
                    <SText fontSize={24} color={STheme.color.text} center>¡Mensaje Enviado!</SText>
                    <SView height={10} />
                    <SText fontSize={16} color={STheme.color.text} center>Revise su bandeja de entrada e introduzca el código recibido. </SText>
                    <SView height={40} />
                    <SView backgroundColor={STheme.color.primary} width={150} height={150} style={{
                        borderRadius: 35,
                    }} center >
                        <SView height={5} ></SView>
                        <Message name={"Message"} width={110} height={110} fill={STheme.color.text} />
                    </SView>
                    <SView height={26} />
                    {this.getForm()}
                  
                    <SView height={36} />
                </SView>
                {/* <RolDeUsuario data={this.usr} /> */}
            </SView>
        </SPage>
    }
}
const styles = StyleSheet.create({
    input: {
        width: "100%",
    },
});